import styled from '@emotion/styled';
import Loader from 'components/Kizen/Loader';

const StyledActivityLoader = styled(Loader)`
  margin-top: calc(-10% + 34px);
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  z-index: 100;
`;

export const CalendarLoader = ({ loading }: { loading: boolean }) =>
  loading ? <StyledActivityLoader loading /> : null;
